import {SiteManagerCustomerBean, siteManagerCustomerSchema} from '@/service/model/sitemanager/SiteManagerCustomerBean'
import {SiteBean, siteSchema} from '@/service/model/SiteBean'
import {SiteManagerMaterialBean, siteManagerMaterialSchema} from '@/service/model/sitemanager/SiteManagerMaterialBean'
import {JSONSchemaType} from 'ajv'

export interface SiteManagerQuotationRequestBean {
  id: string
  reference?: string | null

  customer: SiteManagerCustomerBean
  site: SiteBean

  material: SiteManagerMaterialBean
  material_quantity: number
  material_cadence?: number | null
  material_cadence_periodicity?: number | null
  quarry_material_id?: string | null

  backload_material?: SiteManagerMaterialBean | null
  backload_material_quantity?: number | null
  quarry_backload_material_id?: string | null

  delivered: boolean
  start_day: string
  truck_type?: string | null
  comment?: string | null

  requires_validation: boolean
  fee_percent: number

  doubleFret?: boolean
  materials_display?: Array<{name: string; quantity: number; unit: string; truckType?: string | null; delivered?: boolean; materialType?: string | null}>
  singleOfferCount?: number
  groupedOfferCount?: number
}

export const siteManagerQuotationRequestSchema: JSONSchemaType<SiteManagerQuotationRequestBean> = {
  type: 'object',
  properties: {
    id: {
      type: ['string']
    },
    customer: {
      ...siteManagerCustomerSchema
    },
    site: {
      ...siteSchema
    },
    material: {
      ...siteManagerMaterialSchema
    },
    material_quantity: {
      type: ['number']
    },
    material_cadence: {
      type: ['number'],
      nullable: true
    },
    material_cadence_periodicity: {
      type: ['number'],
      nullable: true
    },
    backload_material: {
      ...siteManagerMaterialSchema,
      nullable: true
    },
    backload_material_quantity: {
      type: ['number'],
      nullable: true
    },
    quarry_material_id: {
      type: ['string'],
      nullable: true
    },
    quarry_backload_material_id: {
      type: ['string'],
      nullable: true
    },
    delivered: {
      type: ['boolean']
    },
    start_day: {
      type: ['string']
    },
    truck_type: {
      type: ['string'],
      nullable: true
    },
    comment: {
      type: ['string'],
      nullable: true
    },
    requires_validation: {
      type: ['boolean']
    },
    fee_percent: {
      type: ['number']
    },
    reference: {
      type: ['string'],
      nullable: true
    },
    doubleFret: {
      type: ['boolean'],
      nullable: true
    },
    materials_display: {
      type: 'array',
      nullable: true,
      items: {
        type: 'object',
        properties: {
          name: {type: 'string'},
          quantity: {type: 'number'},
          unit: {type: 'string'},
          truckType: {type: 'string', nullable: true},
          delivered: {type: 'boolean', nullable: true},
          materialType: {type: 'string', nullable: true},
        },
        required: ['name', 'quantity', 'unit'],
      },
    },
    singleOfferCount: {type: 'number', nullable: true},
    groupedOfferCount: {type: 'number', nullable: true},
  },
  required: [
    'id', 'customer', 'site',
    'material', 'material_quantity',
    'delivered', 'start_day', 'requires_validation', 'fee_percent'
  ],
  additionalProperties: true
}

export const siteManagerQuotationRequestArraySchema: JSONSchemaType<Array<SiteManagerQuotationRequestBean>> = {
  type: 'array',
  items: siteManagerQuotationRequestSchema
}

